import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import template from './lineup-controls.jade'
import {Match} from '../../models'
import '@scoutgg/ftw/source/atoms/button/button'
import notify from '@scoutgg/ftw/source/services/notification'
import checkDuplicates from '../../../helpers/duplicate-names'

const validConfirmed = [
  'confirmed',
  'bench',
  'refuted',
]

const validExpected = [
  'expected',
  'possible',
  'unexpected',
  'suspended',
  'injured',
]

@Component('sporty')
@Template(template)
@Attribute('match', Match)
export default class LineupControls extends HTMLElement {
  async submit(match) {
    var el = document.querySelector('sporty-edit-lineups')
    var lineups = el.lineups

    for(const lineup of lineups) {
      lineup.team = lineup.player.team
    }

    for(const team of match.teams) {
      const hasConfirmed = lineups
        .find(l => l.team === team && l.status === 'confirmed')
      const allUnexpected = 
        lineups.length === lineups
          .filter(l => l.status === 'unexpected').length
      if(hasConfirmed) {
        lineups = lineups
          .filter(l => {
            return l.team !== team || validConfirmed.includes(l.status)
          })
      } else if(!allUnexpected) {
        lineups = lineups
          .filter(l => {
            return l.team !== team || validExpected.includes(l.status)
          })
      }
    }

    this.isDisabled = true
    try {
      await this.checkDuplicateNames(lineups)
      await match.post('lineups', { lineups })
      location.href = `/dashboard/${match}`

    } catch(err) {
      console.error(err)
      notify(err.message, {level: 'danger', timeout: 10000})

    } finally {
      this.isDisabled = false
      this.render()

    }
  }

  checkDuplicateNames(lineups) {
    const checked = lineups
      .filter(l => ['confirmed', 'bench'].includes(l.status))
      .map(l => l.player)
    return checkDuplicates(checked)
  }
}
